import { backendUrl } from '@shared/constants/urls/appUrls';
import { fetchWithAuth } from '@shared/utils/auth';

//Добавить в избранное
export const createPolymarketBookmark = async (objectId, contentType) => {
  const url = `${backendUrl}/api/reactions/bookmarks/create/`;
  const options = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ object_id: objectId, content_type: contentType }),
  };
  return await fetchData(url, options);
};

//Получить избранные трейдов Polymarket
export const getPolymarketTradesBookmarks = async () => {
  const url = `${backendUrl}/api/polymarket/trades/bookmark/`;
  const options = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };
  return await fetchData(url, options);
};

//Общая функция для выполнения запросов
const fetchData = async (url, options = {}) => {
  try {
    const response = await fetchWithAuth(url, options);
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(
        `Ошибка запроса: ${response.status} - ${errorData.message || response.statusText}`
      );
    }
    return await response.json();
  } catch (error) {
    console.error('Ошибка выполнения запроса:', error);
    throw error;
  }
};